import { UntitledIcon } from '@faceup/icons'
import { usCheckCircle } from '@faceup/icons/usCheckCircle'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { ChannelType } from '@faceup/utils'
import type { ReactNode } from 'react'
import { useSurveyPreview } from '../../hooks/useSurveyPreview'
import PageTitle from '../PageTitle'

const messagesPerChannel = defineMessages('followUp.components.sentContent', ChannelType, {
  [ChannelType.AutomatedHotline]: 'Case was sent',
  [ChannelType.LiveHotline]: 'Case was sent',
  [ChannelType.AiHotline]: 'Case was sent',
  [ChannelType.ReportingSystem]: 'Case was sent',
  [ChannelType.Survey]: 'Thank you',
})

type SentContentChannelProps = {
  children?: ReactNode
  description?: ReactNode
  sourceType: ChannelType
  title?: never
}

type SentContentTitleProps = {
  children?: ReactNode
  description?: ReactNode
  title: ReactNode
  sourceType?: never
}

type SentContentProps = SentContentChannelProps | SentContentTitleProps

export const SentContent = (props: SentContentProps) => {
  const { children, description } = props
  const { isPreview } = useSurveyPreview()

  const resolvedTitle: ReactNode = (() => {
    if ('title' in props && props.title !== undefined) {
      return props.title
    }
    if (!('sourceType' in props) || !props.sourceType) {
      return null
    }
    return <FormattedMessage message={messagesPerChannel[props.sourceType]} />
  })()

  return (
    <div
      className='flex flex-col items-center gap-6 w-full px-8'
      data-test='ReportSent'
      inert={isPreview || undefined}
    >
      <UntitledIcon icon={usCheckCircle} size={64} className='text-colorPrimary' />
      <PageTitle description={description}>{resolvedTitle}</PageTitle>
      <div className='flex flex-col gap-6 w-full'>{children}</div>
    </div>
  )
}
